// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetIntegrationTasksRequestModel from '../../model/get-integration-tasks-request-model';
import IntegrationTaskListResultModel from '../../model/integration-task-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getIntegrationTasks(request: GetIntegrationTasksRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-tasks'] ?? 'core/integration/IntegrationTasks';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(IntegrationTaskListResultModel.toModel(dto));
  },
});
